<template>
  <div class="formCla">
    <el-form ref="form" :model="form">
      <el-form-item label="客户id" v-if="show">
        <el-input v-model="form.cusId" size="small" ></el-input>
      </el-form-item>
<!--      <el-form-item label="客户">-->
<!--        <label slot="label">&emsp;&emsp;&emsp;客户</label>-->
<!--        <el-col span="19">-->
<!--          <el-input v-model="form.cusName" size="small"></el-input>-->
<!--        </el-col>-->
<!--      </el-form-item>-->
      <el-form-item label="表">
        <label slot="label">&emsp;&emsp;&emsp;&emsp;表</label>
        <el-col span="19">
          <el-input v-model="form.tableId" size="small"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="表名称">
        <label slot="label">&emsp;&emsp;表名称</label>
        <el-col span="19">
          <el-input v-model="form.tableName" size="small"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item>&emsp;&emsp;
        <el-button type="primary" @click="onSubmit">保存</el-button>&emsp;&emsp;
        <el-button type="primary" @click="cancle">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
    export default {
        name: "addDataSet",
        show: false,
        data() {
            return {
              form: {
                tableId: '',
                tableName: '',
                dsId: this.$route.params.dsId
              }
            }
        },
      mounted() {
        // alert(this.$route.params.cusName.cusName);
        if (this.$route.params.dbId != undefined) {
          this.form.dbSourceId = this.$route.params.dbId;
        }
      },
      methods:{
        cancle() {
          this.$router.push({name:'defineDataSet',params: {avtiveName: 'fifth'}});
        },
        onSubmit() {
          this.$http.post("/dbManage/sys-dataset-detail/addDataSet", this.form).then(resp=>{
            this.$router.push({name:'defineDataSet',params:{avtiveName: 'fifth', addFlag:  '1', dsId: resp.data}})
          })
        }
      }
    }
</script>

<style scoped>
  .formCla{
    width: 60%;
    padding-left: 30%;
    padding-top: 5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/dataSource/addDataSet.vue